// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

// AdvancedSearchLinkWrapper component is used for keyboard highlighting
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AdvancedSearchLinkWrapper = styled.span({
	display: 'flex',
	width: '100%',
});
